import React from 'react';
import { Form } from 'antd';
import { useAppSelector } from '../../../../hooks/store';
import { getIsMobile } from '../../../../redux/selectors';
import { TagSelect } from '../../../../components/tags-select/custom-select-base';
export var SubjectsFormItem = function () {
    var isMobile = useAppSelector(getIsMobile);
    return (React.createElement(Form.Item, { name: "subjects", label: isMobile ? null : 'Subject(s) of interest', rules: [
            {
                required: true,
                message: 'Please select a subject',
            },
        ] },
        React.createElement(TagSelect, null)));
};
